import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fraction'
})
export class FractionPipe implements PipeTransform {
  private gcd(a: number, b: number): number {
    return b === 0 ? a : this.gcd(b, a % b);
  }


  transform(value: number): unknown {
    if (value % 1 === 0) {
      return `${value}`; // Return integer as fraction over 1
    }

    const accrual = value - value % 1; // this gives us the whole number
    const fractionate = value - accrual; // this gives us the fractional part

    const wholeNumber = accrual > 0 ? `${accrual}-` : '';

    const decimalLength = fractionate.toString().split('.')[1].length;
    const denominator = Math.pow(10, decimalLength);
    const numerator = fractionate * denominator;
    const divisor = this.gcd(Math.round(numerator), denominator);

    return `${wholeNumber}${Math.round(numerator) / divisor}/${denominator / divisor}`;
  }

}
